import { Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FormikProps } from 'formik';
import BookingsButton from '../BookingsButton';
import StyledTypography from '../../Common/StyledTypography';
import OfficeDetails from './OfficeDetails';
import { FormValues } from '../../../utils/validations/officeDetailsForm';

type IInPersonConsultationsStepProps = {
  isProvideInPersonConsultations: boolean | null;
  setIsProvideInPersonConsultations: (_isProvideInPersonConsultations: boolean | null) => void;
  isProvideOnlineConsultations: boolean | null;
  formik: FormikProps<FormValues>;
  hasPermissions: boolean;
};

function InPersonConsultationsStep({
  isProvideInPersonConsultations,
  setIsProvideInPersonConsultations,
  isProvideOnlineConsultations,
  formik,
  hasPermissions,
}: IInPersonConsultationsStepProps) {
  const { t } = useTranslation();

  return (
    <Grid display="flex" flexDirection="column" alignItems="center" height="calc(100% - 68px)">
      <Grid gap={2} display="flex" flexDirection="column" alignItems="center">
        <Typography variant="title1Bold" color="primary">
          {t('bookings.inPersonConsultationsStep.title')}
        </Typography>
        {isProvideInPersonConsultations && (
          <Grid display="flex" flexDirection="row" gap="20px">
            <BookingsButton
              onClick={() => setIsProvideInPersonConsultations(true)}
              isSelected={isProvideInPersonConsultations}
              disabled={!hasPermissions}
            >
              {t('bookings.onlineConsultationsStep.yes')}
            </BookingsButton>
            <BookingsButton
              paddingX={93}
              onClick={() => {
                formik.setFieldValue('address', '');
                formik.setFieldValue('isAddressPublic', false);
                formik.setFieldValue('phoneNumber', '');
                formik.setFieldValue('isPhoneNumberPublic', false);
                setIsProvideInPersonConsultations(false);
              }}
              isSelected={
                isProvideInPersonConsultations !== null && !isProvideInPersonConsultations
              }
              disabled={!hasPermissions}
            >
              {t('bookings.onlineConsultationsStep.no')}
            </BookingsButton>
          </Grid>
        )}
        {isProvideInPersonConsultations === false && isProvideOnlineConsultations === false && (
          <Grid display="flex" flexDirection="row" gap="20px">
            <BookingsButton
              onClick={() => setIsProvideInPersonConsultations(true)}
              isSelected={isProvideInPersonConsultations}
              disabled={!hasPermissions}
            >
              {t('bookings.onlineConsultationsStep.yes')}
            </BookingsButton>
            <BookingsButton
              paddingX={93}
              onClick={() => setIsProvideInPersonConsultations(false)}
              isSelected={
                isProvideInPersonConsultations !== null && !isProvideInPersonConsultations
              }
              disabled={!hasPermissions}
            >
              {t('bookings.onlineConsultationsStep.no')}
            </BookingsButton>
          </Grid>
        )}
      </Grid>
      {!isProvideInPersonConsultations &&
        !(isProvideInPersonConsultations === false && isProvideOnlineConsultations === false) && (
          <Grid
            display="flex"
            justifyContent="center"
            m="auto"
            gap="20px"
            width="100%"
            flexDirection="row"
            alignItems="center"
          >
            <BookingsButton
              onClick={() => setIsProvideInPersonConsultations(true)}
              isSelected={isProvideInPersonConsultations}
              disabled={!hasPermissions}
            >
              {t('bookings.onlineConsultationsStep.yes')}
            </BookingsButton>
            <BookingsButton
              paddingX={93}
              onClick={() => setIsProvideInPersonConsultations(false)}
              isSelected={
                isProvideInPersonConsultations !== null && !isProvideInPersonConsultations
              }
              disabled={!hasPermissions}
            >
              {t('bookings.onlineConsultationsStep.no')}
            </BookingsButton>
          </Grid>
        )}
      {isProvideInPersonConsultations && (
        <Grid
          display="flex"
          justifyContent="center"
          m="auto"
          gap={3}
          width="100%"
          flexDirection="column"
          alignItems="center"
        >
          <Typography variant="h6" color="primary">
            {t('bookings.inPersonConsultationsStep.yourOfficeDetails')}
          </Typography>
          <OfficeDetails formik={formik} hasPermissions={hasPermissions} />
        </Grid>
      )}
      {isProvideInPersonConsultations === false && isProvideOnlineConsultations === false && (
        <Grid
          display="flex"
          justifyContent="center"
          m="auto"
          gap="12px"
          width="100%"
          flexDirection="row"
          alignItems="center"
        >
          <img src="/assets/icons/shield-warning-red-bold.svg" alt="" width={24} height={27} />
          <StyledTypography variant="bodyBold">
            <span> {t('bookings.inPersonConsultationsStep.error')}</span>
          </StyledTypography>
        </Grid>
      )}
    </Grid>
  );
}

export default InPersonConsultationsStep;
